module.exports = __webpack_public_path__ + "static/media/shoppingBag.0af4f3d4.svg";